import "@/confs/common.conf.js";
import Vue from 'vue';
import Vuex from 'vuex';
import VueSession from 'vue-session';
import CommonConst from '@/plugins/common.const.plugin';
import commonStore from '@/stores/common.store';
import airStore from '@/stores/air.store';
import covidStore from '@/stores/covid.store';
import App from '@/views/covid/CovidApp.vue';
import VueRouter from "vue-router";
import Meta from 'vue-meta';

fetchCurrentUser().then(currentUser => {
    Vue.use(VueSession, {persist: true});
    Vue.use(Vuex);
    Vue.use(CommonConst);
    Vue.use(VueRouter);
    Vue.use(Meta, {
        attribute: 'data-vue-meta',
    });

    const store = new Vuex.Store({
        modules: {
            commonStore,
            airStore,
            covidStore,
        }
    });

    let router = new VueRouter({
        mode: 'history',
        routes: []
    });

    let $vue = new Vue({
        render: h => h(App),
        router,
        store,
    });
    $vue.$session.set('currentUser', currentUser);
    setMenus($vue, currentUser.menuList);
    fetchPageRoller().then(roller => {
        $vue.$session.set('rollerData', roller.data);
        $vue.$mount('#app');
    });
});
